
import request from '../../../request';
import { hideLoading, showLoading } from '../../../loading';
import swal from 'sweetalert';
import ResponsiveTable from "../../../components/ResponsiveTable";
import Gender from '../../../components/Gender';
import { IconButton } from "@mui/material";
import { Delete as DeleteIcon, Visibility } from '@mui/icons-material';
import { requestConfirmation } from '../../../utils';
import DateTime from "../../../components/DateTime";
import Email from "../../../components/Email";
import Phone from "../../../components/Phone";
import { Link } from "react-router";
import Address from "../../../components/Address";
import PillLabel from "../../../components/PillLabel";
import NavigationStateSaver from "../../../components/NavigationStateSaver";
import { getCustomerFullName } from '../../../../../shared/utils';


export default class List extends NavigationStateSaver {

   state = {
      customers: null,
      page: 0,
      total: 0,
      limit: 10,
      search: '',
   }


   fetchCustomers = async () => {

      try {

         showLoading();

         const {  page, limit, search } = this.state
         const params = {
            page: page + 1,
            limit
         }

         if (search)
            params.search = search;

         const res = await request.get('/api/general/customers', { params });
         const { total, customers } = res.data;

         this.setState({ total, customers });

      } catch (err) {
         swal("Error", err.toString(), "error");
      } finally {
         hideLoading();
      }
   }

   deleteCustomer = async (customer) => {

      // confirm
      const question = `Are you sure you want to delete customer "${getCustomerFullName(customer)}"?`
      const confirm = await requestConfirmation(question);

      if (!confirm)
         return;

      try {

         showLoading();

         await request.delete(`/api/general/customers/${customer._id}`);
         const customers = this.state.customers.filter(a => a._id !== customer._id);
         this.setState({ customers });

      } catch (err) {
         swal("Error", err.toString(), "error");
      } finally {
         hideLoading();
      }
   }

   async componentDidMount() {
      await super.componentDidMount();
      if (!this.state.customers)
         this.fetchCustomers();
   }

   render() {

      return <>
         <ResponsiveTable
            cols={[
               {
                  field: 'name',
                  caption: 'Name',
                  render: (_, customer) => getCustomerFullName(customer)
               },
               {
                  field: 'gender',
                  caption: 'Gender',
                  render: gender => gender ? <Gender gender={gender} /> : <PillLabel>N/A</PillLabel>
               },
               { 
                  field: 'email', 
                  caption: 'Email',
                  render: email => email ? <Email email={email} /> : '–'
               },
               {
                  field: 'phone',
                  caption: 'Phone',
                  render: phone => phone ? <Phone phone={phone} /> : '–'
               },
               {
                  field: 'address',
                  caption: 'Address',
                  render: address => address ? <Address address={address} /> : '–'
               },
               {
                  field: 'dob',
                  caption: 'DOB',
                  render: dob => dob ? <DateTime value={dob} dateOnly /> : <PillLabel>N/A</PillLabel>
               },
               { field: 'national_id', caption: 'National ID' },
               {
                  field: 'actions',
                  caption: '',
                  render: (_, customer) => <div className="flex gap-1">
                     <IconButton
                        onClick={() => this.deleteCustomer(customer)}
                        size="small"
                        color="error"
                     >
                        <DeleteIcon fontSize="small" />
                     </IconButton>
                     <Link to={`/dashboard/customers/${customer._id}`}>
                        <IconButton size="small">
                           <Visibility fontSize="small" />
                        </IconButton>
                     </Link>
                  </div>
               }
            ]}
            rows={this.state.customers}
            fullHeight
            onRefresh={this.fetchCustomers}
            pagination={{
               page: this.state.page,
               rowsPerPage: this.state.limit,
               count: this.state.total,
               labelRowsPerPage: "Customers per page",
               onPageChange: async (e, page) => {
                  await this.updateState({ page });
                  this.fetchCustomers();
               },
               onRowsPerPageChange: async (e) => {
                  const limit = e.target.value;
                  await this.updateState({ limit, page: 0 });
                  this.fetchCustomers();
               }
            }}
            search={{
               placeholder: 'Search by full name',
               query: this.state.search,
               onChange: search => this.updateState({ search }),
               onSearch: async () => {
                  await this.updateState({ page: 0 });
                  this.fetchCustomers();
               }
            }}
         />
      </>
   }
}